import React from 'react';
import { connect } from 'react-redux';
import videoUtils from '../utils/VideoUtils';
import storeManager from '../../store/StoreManager';

const ShadowAreaContent = React.createClass({
    render() {
        var width;
        var leftPosition;

        if (this.props.index == 0) {
            width = videoUtils.leftMarkerPosition;
            leftPosition = 0;
        } else {
            width = this.props.trackWidth - videoUtils.rightMarkerPosition;
            leftPosition = videoUtils.rightMarkerPosition;
        }
        const shadowStyle = {
            position: 'absolute',
            userDrag: 'none',
            WebkitUserSelect: 'none',
            userSelect: 'none',
            width: width,
            height: this.props.trackHeight,
            opacity: 0.6,
            background: 'black',
            left: leftPosition
        };

        return (
            <div style={shadowStyle}/>
        );
    }
});

function mapStateToProps () {
    const state = storeManager.getState();
    const updateValue = state.menu.updateValue;

    return {
        updateValue
    };
}

export const ShadowArea = connect(mapStateToProps)(ShadowAreaContent);



/** WEBPACK FOOTER **
 ** ./src/components/videoEditor/ShadowArea.js
 **/